<template>
  <div>
    <p class="mb-3 inline-block text-sm opacity-40">
      <slot />
    </p>
    <ul class="flex flex-wrap gap-[0.625rem] sm:gap-4">
      <li>
        <button
          class="gradient-transition-effect relative overflow-hidden rounded-sm bg-blue-200/20 bg-gradient-to-tr px-4 py-2 text-base first-letter:uppercase after:bg-gradient-to-tr after:from-blue-800 after:to-blue-600 sm:px-5 sm:py-3 sm:text-md sm:font-medium"
          :class="{
            'text-white after:opacity-100': !selected,
            'text-blue-800 hover:text-white': selected,
          }"
          @click="$emit('filter', null)"
        >
          {{ buttonAllText }}
        </button>
      </li>

      <li v-for="term in terms" :key="term.id">
        <button
          class="gradient-transition-effect relative overflow-hidden rounded-sm bg-blue-200/20 bg-gradient-to-tr px-4 py-2 text-left text-base after:bg-gradient-to-tr after:from-blue-800 after:to-blue-600 sm:px-5 sm:py-3 sm:text-md sm:font-medium"
          :class="{
            'text-white after:opacity-100': selected === term.slug,
            'text-blue-800 hover:text-white': selected !== term.slug,
          }"
          @click="$emit('filter', term.slug)"
        >
          {{ term.title }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script setup>
const props = defineProps({
  terms: {
    type: Array,
    default: () => [],
  },

  filtered: {
    type: String,
    default: null,
  },

  buttonAllText: {
    type: String,
    default: 'Alle',
  },
})

const selected = ref(null)

// must watch on this prop and wait for one tick to handle timing issues (appears only builded)
watch(
  () => props.filtered,
  async (newVal) => {
    await nextTick()
    selected.value = newVal
  },
  { immediate: true }
)

defineEmits(['filter'])
</script>
